export default __webpack_public_path__ + "static/media/plane-icon.080c04bb.svg";